import React from "react";
import {
  ToolBar,
  ToolBarName,
  NameBar,
  NameBarFill,
  ToolBarTiles,
  ToolBarEntries,
  ToolBarButton,
  ToolBarEntry,
  ToolBarEntryText,
} from "../styles/components.js";

const navLinks = [
  { label: "GitHub", href: "https://github.com/c3llus", external: true },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/c3llus/", external: true },
  // { label: "Blog", href: "https://blog.c3llus.dev", external: true },
  { label: "Projects", href: "/projects", external: false },
];

export const Navbar = () => {
  return (
    <ToolBar>
      <ToolBarName>
        <NameBarFill />
        <NameBar>
          <a href="/" style={{ textDecoration: "none", color: "inherit" }}>
            Marcellus
          </a>
        </NameBar>
        <NameBarFill />
      </ToolBarName>
      <ToolBarTiles>
        <ToolBarEntries>
          {navLinks.map(({ label, href, external }) => (
            <ToolBarButton
              key={label}
              href={href}
              {...(external && { target: "_blank", rel: "noopener noreferrer" })}
            >
              <ToolBarEntry>
                <ToolBarEntryText>{label}</ToolBarEntryText>
              </ToolBarEntry>
            </ToolBarButton>
          ))}
        </ToolBarEntries>
      </ToolBarTiles>
    </ToolBar>
  );
};
